import { css } from "@emotion/react";

export const container = css`
  width: 100%;
`;

export const waitlistCta = css`
  margin-top: 16px;
`;
